export enum PortailEnum {
    portailIris,
    portailChantier,
}
